import styles from "./page.module.css";

import { observer, inject } from "mobx-react";
import { MariDataStore } from "./store/store";
import MariGrid from "./components/manage-maris.grid";
import Header from "./components/header/header";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { TransitionStore } from "../../store";

interface IMariProps {
  mariDataStore: MariDataStore;
  transitionStore: TransitionStore;
}

function Maris(props: IMariProps) {
  const { ready: readyCameraGrid } = useTranslation("mari-grid");
  const { ready: readySearch } = useTranslation("search-mari");
  const { ready: readyCommon } = useTranslation("common");
  const { mariDataStore, transitionStore } = props;
  const {
    isDataLoading,
    isTranslationLoading,
    isSaveLoading,
    isDeleteLoading,
  } = mariDataStore;
  const languagesLoaded = readyCameraGrid && readySearch && readyCommon;

  useEffect(() => {
    return () => {
      mariDataStore.resetSelectedData();
      mariDataStore.closeExpanded();
      transitionStore.isPromptShown = false;
    };
  }, []);

  useEffect(() => {
    if (!languagesLoaded) {
      mariDataStore.setIsTranslationLoading(true);
    } else {
      mariDataStore.setIsTranslationLoading(false);
    }

    if (
      isDataLoading ||
      isTranslationLoading ||
      isSaveLoading ||
      isDeleteLoading
    ) {
      transitionStore.setLoading(true);
    } else {
      transitionStore.setLoading(false);
    }
  });

  useEffect(() => {
    transitionStore.isPromptShown = mariDataStore.hasSelectedMari;
  }, [mariDataStore.hasSelectedMari]);

  const render = () => {
    return (
      <>
        {languagesLoaded && (
          <>
            <Header />
            <div
              id="grid-container"
              className={styles["manage-maris-grid-container"]}
            >
              <div className={styles["overflow-content"]}>
                <MariGrid />
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return render();
}

export default inject("mariDataStore", "transitionStore")(observer(Maris));
